import { FormattedMessage } from 'react-intl'

import { IconQuestionMarkCircle } from '@gto/ui/assets'
import { Typography } from '@gto/ui/typography'

import { CategoryColorMapping } from '@/pages/rewards/constants'

import { CategoryColorBadge } from './category-color-badge'

export const EarningsTableFooter = () => {
  return (
    <div className="flex gap-4 bg-paper-elevation3 px-4 pb-4 pt-2">
      {/*
        A flex row rather than an inline icon inside a block `Typography`: as a narrow flex item
        the label wrapped onto its own line under the 24px icon. `shrink-0` keeps it whole when
        the legend beside it needs the room.
      */}
      <div className="flex shrink-0 items-center gap-1">
        <IconQuestionMarkCircle width={24} />
        <Typography
          className="font-semibold"
          color="text.primary"
          variant="body3"
        >
          <FormattedMessage id="rewards.earnings.table.lastUpdated" />
        </Typography>
      </div>

      <div className="flex flex-wrap items-center gap-x-4 gap-y-1">
        {Object.entries(CategoryColorMapping).map(([category, color]) => (
          <div
            key={category}
            className="flex items-center gap-2"
          >
            <CategoryColorBadge
              category={category as keyof typeof CategoryColorMapping}
              color={color}
            />
            <Typography
              color="text.secondary"
              variant="body3"
            >
              {category}
            </Typography>
          </div>
        ))}
      </div>
    </div>
  )
}
